import '@loyal_molecules/footer.css'
import Nps from 'features/Nps'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ReactPlaceholder from 'react-placeholder'
import 'react-placeholder/lib/reactPlaceholder.css'
import FooterPlaceholder from './FooterPlaceholder'
import FooterContent from './FooterContent'
import { getButton } from 'Shared/GTM/getButton'

class Footer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      profileMenu: false,
      userMenu: false,
      categoryMenu: true,
      isHomeOrGuest: false,
      isHelpPage: false,
      isProfile: false,
      isCartPage: false,
      openNPS: false,
      showIuppMobileMenu: false
    }
  }

  openNPS = () => {
    this.setState({
      openNPS: !this.state.openNPS
    })
  }

  render () {
    return (
      <ReactPlaceholder ready customPlaceholder={<FooterPlaceholder />}>
        {process.env.REACT_APP_NPS_BUTTON && this.state.openNPS && (
          <Nps urlNps={process.env.REACT_APP_NPS_BUTTON} closeDonation />
        )}
        <footer id='footer' title='rodapé' className='box-footer d-print-none'>
          {process.env.REACT_APP_NPS_BUTTON && this.props.profile && (
            <button className='btnFeedBack'
              onClick={() => {
                this.openNPS()
                getButton(this.props.profile, 'home', 'clique:menu', 'deixe-sua-opiniao')
              }}
            >
              Deixe sua opinião
            </button>
          )}
          <FooterContent profile={this.props.profile} footerMenu={this.props.footerMenu} meuBairro={this.props.meuBairro} />
        </footer>
      </ReactPlaceholder>
    )
  }
}

Footer.propTypes = {
  profile: PropTypes.object,
  footerMenu: PropTypes.object,
  meuBairro: PropTypes.bool
}

export default Footer



// WEBPACK FOOTER //
// ./src/App/Footer/Footer.js